import * as Immutable from "immutable";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class ZendeskChatHandoverRecord
 * @augments BaseMessageRecord
 */
class ZendeskChatHandoverRecord extends BaseMessageRecord({
  type: "zendesk_handover",

  /**
   * @memberof ZendeskChatHandoverRecord#
   */
  unavailableAnswerId: null,
  acknowledgementBody: ""
}) {}

/**
 * Validation
 */

/**
 * @param {ZendeskChatHandoverRecord} message
 * @returns {Immutable.List.<String>}
 */
ZendeskChatHandoverRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!message.acknowledgementBody) {
    invalidFields.add("acknowledgementBody");
  }

  if (!message.unavailableAnswerId) {
    invalidFields.add("unavailableAnswerId");
  }

  return Immutable.List(invalidFields);
};

export default ZendeskChatHandoverRecord;
